export default __webpack_public_path__ + "static/media/assignment-printouts2.9123410c.pdf";